import { React, useState, forwardRef, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Toasts(props) {
  const [toast, setToast] = useState(props);

  useEffect(() => {
    setToast(props);
  }, [props]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setToast({ open: false });
  };

  return (
    <Snackbar open={toast.open} autoHideDuration={3000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={toast.variant}>
        {toast.message}
      </Alert>
    </Snackbar>
  );
}
